/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_1_TitleInputs */

const en_gc_search_guides_gridcraft_online_sections_1_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open your file or make one small edit`)
};

const zh_gc_search_guides_gridcraft_online_sections_1_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开文件或先做一次小修改`)
};

/**
* | output |
* | --- |
* | "Open your file or make one small edit" |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_1_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_1_title = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_1_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_1_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_1_title(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_1_title(inputs)
});
export { gc_search_guides_gridcraft_online_sections_1_title as "gc.search_guides.gridcraft_online.sections.1.title" }